import { render } from "./pricing-details.vue?vue&type=template&id=4fcb51f2&lang=pug"
import script from "./pricing-details.vue?vue&type=script&lang=js"
export * from "./pricing-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__